import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Title {
  pageTitle = signal<string>('Dashboard');

  setTitle(newTitle: string) {
    this.pageTitle.set(newTitle);
  }
}
